import { buildModelManager } from "../builder.js";
const DefaultSegmentMembershipSelection = {
  __typename: true,
  id: true,
  contactId: true,
  createdAt: true,
  customerId: true,
  segmentId: true,
  updatedAt: true
};
const modelApiIdentifier = "segmentMembership";
const pluralModelApiIdentifier = "segmentMemberships";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByContact",
    findByField: "contactId",
    findByVariableName: "contactId",
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByContact",
    findByField: "contactId",
    findByVariableName: "contactId",
    modelApiIdentifier,
    defaultSelection: DefaultSegmentMembershipSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSegmentMembership",
    operationReturnType: "CreateSegmentMembership",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      segmentMembership: { required: false, type: "CreateSegmentMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSegmentMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSegmentMemberships",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSegmentMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSegmentMembershipSelection
  },
  {
    type: "action",
    operationName: "updateSegmentMembership",
    operationReturnType: "UpdateSegmentMembership",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      segmentMembership: { required: false, type: "UpdateSegmentMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSegmentMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateSegmentMemberships",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateSegmentMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSegmentMembershipSelection
  },
  {
    type: "action",
    operationName: "deleteSegmentMembership",
    operationReturnType: "DeleteSegmentMembership",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSegmentMemberships",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSegmentMembership",
    operationReturnType: "UpsertSegmentMembership",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      segmentMembership: { required: false, type: "UpsertSegmentMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSegmentMembershipResult": { hasReturnType: false },
      "... on UpdateSegmentMembershipResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSegmentMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertSegmentMemberships",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertSegmentMembershipsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSegmentMembershipSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "segmentMembershipGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SegmentMembershipManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSegmentMembershipSelection,
  operations
);
export {
  DefaultSegmentMembershipSelection,
  SegmentMembershipManager
};
//# sourceMappingURL=SegmentMembership.js.map
